import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/invisalign/hero";
import WhatAndWhy from "../components/invisalign/what-and-why";
import Process from "../components/invisalign/process";
import AfterCare from "../components/invisalign/aftercare";
import Benifits from "../components/invisalign/benefits";
import CTA from "../components/invisalign/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import QuestionsInvisalign from "../components/invisalign/Question";

function Index() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Invisalign® in Ilkley, West Yorkshire | Regent Dental",
    serviceType: "Invisalign Treatment",
    url: "https://www.regent-dental.co.uk/invisalign",
    description:
      "At Regent Dental, we offer expert Invisalign treatment to help straighten teeth discreetly and comfortably. Ideal for teens and adults looking for a confident smile without traditional braces.",
    provider: {
      "@type": "LocalBusiness",
      "@id": "http://regent-dental.co.uk/#localbusiness",
      name: "Regent Dental",
      image:
        "https://www.regent-dental.co.uk/static/media/3.4c51da854dc4cc666630.png",
      url: "http://regent-dental.co.uk/",
      telephone: "+01943 661331",
      openingHours: "Mo-Fr 09:00-17:00",
      priceRange: "$$",
      sameAs: [
        "https://www.facebook.com/people/Regent-Dental/61564954080373/",
        "https://www.instagram.com/regentdental_ilkley/",
        "https://g.co/kgs/EY9shTo",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "2A Regent Rd",
        addressLocality: "Ilkley",
        addressRegion: "England",
        postalCode: "LS29 9EA",
        addressCountry: {
          "@type": "Country",
          name: "UK",
        },
      },
      areaServed: [
        { "@type": "Place", name: "Ilkley" },
        { "@type": "Place", name: "Keighley" },
        { "@type": "Place", name: "Skipton" },
        { "@type": "Place", name: "Otley" },
        { "@type": "Place", name: "Silsden" },
      ],
    },
  };
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What are NiTime aligners?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "NiTime aligners are a discreet, removable orthodontic treatment designed to straighten your teeth - and the best part is you only need to wear them at night!",
        },
      },
      {
        "@type": "Question",
        name: "How do NiTime aligners work?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "NiTime aligners gently move your teeth into the desired position while you sleep, offering a comfortable and convenient way to achieve a beautifully straighter smile with minimal daytime wear.",
        },
      },
      {
        "@type": "Question",
        name: "How many hours a day do I need to wear NiTime aligners?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "You only need to wear NiTime aligners for around at least 12 hours each day, mainly during the evening and overnight, making them perfect for busy lifestyles.",
        },
      },
      {
        "@type": "Question",
        name: "Are NiTime aligners suitable for everyone?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "NiTime aligners are ideal for mild to moderate orthodontic cases. We’ll assess your smile at your consultation to see if you’re a good candidate.",
        },
      },
      {
        "@type": "Question",
        name: "How do I get started with NiTime aligners at Regent Dental?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Booking a consultation is easy - just get in touch with us! We’ll assess your smile, discuss your goals, and create a tailored treatment plan to help you achieve your dream smile with NiTime.",
        },
      },
      {
        "@type": "Question",
        name: "How long does treatment with NiTime aligners take?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Treatment times vary depending on your individual case, but most patients complete their journey to a straighter smile in as little as 6–18 months.",
        },
      },
      {
        "@type": "Question",
        name: "Will NiTime aligners affect my speech?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Because you wear them mainly while sleeping, any minor adjustment to your speech is usually minimal and short-lived.",
        },
      },
      {
        "@type": "Question",
        name: "Are NiTime aligners comfortable to wear?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes! NiTime aligners are custom-made to fit your teeth precisely, so they are smooth, comfortable, and easy to wear throughout the night.",
        },
      },
      {
        "@type": "Question",
        name: "Can I eat and drink with NiTime aligners in?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We recommend removing your aligners before eating or drinking anything other than water. This helps protect both your aligners and your teeth.",
        },
      },
      {
        "@type": "Question",
        name: "How do I keep my aligners clean?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Simply rinse them with cool water and gently brush them with a soft toothbrush daily. We’ll also share our top tips for keeping them fresh and clear.",
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        <title>
          Invisalign&#174; in Ilkley, West Yorkshire | Regent Dental
        </title>
        <meta
          name="description"
          content="Straighten your teeth discreetly with Invisalign in West Yorkshire. Regent Dental provides custom clear aligners for comfortable, nearly invisible treatment."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/invisalign"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData2)}
        </script>
      </Helmet>
      <Navbar />
      <Header />
      <WhatAndWhy />
      <Process />
      <AfterCare />
      <Benifits />
      <QuestionsInvisalign />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
